import React from 'react';

// Drawn medallion chips — replaces 🥇🥈🥉 emoji everywhere (design law: no emoji
// glyphs in UI). Ranks 1/2/3 get metal gradients (gold keeps its glow halo);
// ranks 4+ render as quiet numeric chips.
const METALS = {
  1: { background: 'linear-gradient(145deg,#FFD54A,#B8860B)', color: '#3A2A00', boxShadow: '0 0 12px rgba(255,213,74,0.35)' },
  2: { background: 'linear-gradient(145deg,#E2E8F0,#94A3B8)', color: '#2A3240', boxShadow: 'none' },
  3: { background: 'linear-gradient(145deg,#E0A86B,#8C5A2B)', color: '#3A2410', boxShadow: 'none' },
};

export default function MedalBadge({ rank, size = 26 }) {
  const metal = METALS[rank];
  const base = {
    width: size, height: size, borderRadius: '50%', position: 'relative', flex: 'none',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'Oswald, sans-serif', fontWeight: 900, fontSize: size * 0.46,
    fontVariantNumeric: 'tabular-nums',
  };
  if (!metal) {
    return (
      <span style={{ ...base, background: '#1C1C1C', border: '1px solid #333', color: '#666' }}>
        {rank}
      </span>
    );
  }
  return (
    <span style={{ ...base, ...metal }}>
      <span aria-hidden="true" style={{
        position: 'absolute', inset: Math.max(2, size * 0.1), borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.25)', pointerEvents: 'none',
      }} />
      {rank}
    </span>
  );
}
